import { render } from "./PlantillasEmail.vue?vue&type=template&id=a1d16cc6&scoped=true&ts=true"
import script from "./PlantillasEmail.vue?vue&type=script&lang=ts"
export * from "./PlantillasEmail.vue?vue&type=script&lang=ts"

import "./PlantillasEmail.vue?vue&type=style&index=0&id=a1d16cc6&lang=scss&scoped=true"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d16cc6"]])

export default __exports__